<template>
	<div>
		<div class="videoupload">
			<!-- action必选参数, 上传的地址 -->
			<el-upload
				class="avatar-uploader el-upload--text"
				:data="additionalData"
				:headers="headers"
				:disabled="imageUrl != '' && !isFactor && isFactorVideo"
				:uploadImgUrl="uploadImgUrl"
				:show-file-list="false"
				:on-success="handleVideoSuccess"
				:before-upload="beforeUploadVideo"
				:on-progress="uploadVideoProcess"
				style="padding: 0; text-align: center">
				<i v-if="!imageUrl && videoFlag == false" class="el-icon-plus" style="font-size: 30px; border: 0px; width: 220px; height: 123px; line-height: 123px; margin-top: -13px; margin-left: -8px"></i>
				<div style="position: relative" :style="{ visibility: imageUrl ? 'visible' : 'hidden' }">
					<video ref="videoPlay" :src="imageUrl" width="224" height="126" style="background-color: black; margin-left: -10px" controls="controls">您的浏览器不支持视频播放</video>
				</div>
			</el-upload>
		</div>
		<p style="color: #bbb; font-size: 10px">文件后缀名可为{{ fileType.join('/') }}，文件大小不得大于{{ fileSize }}M。</p>
	</div>
</template>

<script setup>
import { ElMessage } from 'element-plus'
import { getToken } from '@/utils/auth'
import defaultSettings from '@/settings'
import defaultImgs from '@/images'

const emit = defineEmits(['update:modelValue'])

const props = defineProps({
	// 父组件 v-model 没有指定参数名，则默认是 modelValue
	modelValue: [String, Object, Array],
	src: String,
	isFactor: {
		// 是否是厂商默认是
		type: Boolean,
		default: true
	},
	isFactorVideo: {
		// 视频是否是厂商的，默认是
		type: Boolean,
		default: true
	},
	// 大小限制(MB)
	fileSize: {
		type: Number,
		default: 30
	},
	// 文件类型, 例如['png', 'jpg', 'jpeg']
	//AVI、MP4、DAT、DVR、VCD、MOV、SVCD、VOB、DVD、DVTR、DVR、BBC、EVD、FLV、RMVB、WMV、MKV、3GP
	fileType: {
		type: Array,
		default: () => ['avi', 'mp4', 'vcd', 'flv', 'wmv']
	}
})

const uploadImgUrl = ref(defaultSettings.fileUploadUrl) // 上传的图片服务器地址
const imageUrl = ref(defaultImgs.defaultImg)
const additionalData = ref({
	belongApp: defaultSettings.app,
	belongAppId: defaultSettings.appId
})

const headers = ref({ Authorization: 'Bearer ' + getToken() })
const videoFlag = ref(false)

const clearVideo = () => {
	imageUrl.value = ''
	emit('update:modelValue', '')
}
const handleVideoSuccess = (res, file) => {
	videoFlag.value = false
	if (res && res.ResData) {
		commonUpdateSrc(res.ResData.FilePath)
	} else {
		ElMessage.error('视频上传失败，请重新上传！')
	}
}
const commonUpdateSrc = (src) => {
	//如果动态切换src地址，也要加上下面的事件（前提是src地址已切换或已重新赋值，再走这个事件）
	nextTick(() => {
		emit('update:modelValue', src)
		imageUrl.value = src
	})
}
const uploadVideoProcess = (event, file, fileList) => {
	videoFlag.value = true
}
const beforeUploadVideo = (file) => {
	const isLt40M = file.size / 1024 / 1024 <= 40
	if (['video/mp4'].indexOf(file.type) == -1) {
		ElMessage.error('请上传正确的视频格式')
		return false
	}
	if (!isLt40M) {
		ElMessage.error('上传视频大小不能超过40MB哦!')
		return false
	}
}
// 因为props.modelValue是非引用类型，改变时，需要监听，对响应式数据重新赋值
watch(
	() => props.modelValue,
	(val) => {
		if (val != null && val != '') {
			//如果是远程文件则直接赋值
			imageUrl.value = val
		}
	}
)
//页面加载时
onMounted(() => {
	if (imageUrl.value != null && imageUrl.value != '') {
		emit('update:modelValue', imageUrl.value)
		videoFlag.value = true
	}
})
</script>

<style lang="scss" scoped>
.videoupload {
	width: 220px;
	height: 123px;
	background-color: #fbfdff;
	border: 1px dashed #c0ccda;
	border-radius: 6px;
}
</style>
